import React, { useEffect, useRef } from 'react';
import {
  createScriptElement,
  appendScripts,
  removeScripts
} from 'lib/scriptHandler';

interface AdPopupType {
  adSrc: string;
  gcmSrc: string;
  gcmInfo: string;
  cardNo: string;
}

const AdPopup: React.FC<AdPopupType> = ({ adSrc, gcmSrc, gcmInfo, cardNo }) => {
  const adDiv = useRef<HTMLDivElement | null>(null);
  const gcmInfoDiv = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const mediaInfoScript = createScriptElement(`
      var ${gcmInfo} = {
        "mc": {
          "%%fluct_ppid%%": "${cardNo}"
        }
      };
    `);
    const adLoaderScript = createScriptElement(adSrc, true);
    const gcmLoaderScript = createScriptElement(gcmSrc, true);

    if (gcmInfoDiv.current) {
      appendScripts(gcmInfoDiv.current, [mediaInfoScript]);
    }

    if (adDiv.current) {
      appendScripts(adDiv.current, [adLoaderScript, gcmLoaderScript]);
    }

    return () => {
      if (gcmInfoDiv.current) {
        removeScripts(gcmInfoDiv.current, [mediaInfoScript]);
      }

      if (adDiv.current) {
        removeScripts(adDiv.current, [adLoaderScript, gcmLoaderScript]);
      }
    };
  }, [adSrc, gcmSrc, gcmInfo, cardNo]);

  return (
    <>
      <div ref={gcmInfoDiv}></div>
      <div
        ref={adDiv}
        className="gsm-gcm-ad"
        style={{ margin: '0 auto', padding: 0, position: 'relative' }}
      ></div>
    </>
  );
};

export default AdPopup;
